module.exports = __webpack_public_path__ + "img/case-bank.9d47e751.png";